import { logDispatcher } from 'src/app/core/decorators/state.decorators';
import { HolidaysForm } from '../models/holidays-form.model';
import { HolidaysSchool, HolidaysSchoolRequest } from '../models/holidays-response.model';

export namespace HolidaysActions {

  @logDispatcher
  export class GetHolidaysSchool {
    static readonly type = '[Holidays] GetHolidaysSchool';
    constructor(public schoolId: number, public exerciseId: number) {}
  }

  @logDispatcher
  export class GetHolidaysSchoolSuccess {
    static readonly type = '[Holidays] GetHolidaysSchoolSuccess';
    constructor(public holidaysSchool: HolidaysSchool) {}
  }

  @logDispatcher
  export class AddHoliday {
    static readonly type = '[Holidays] AddHoliday';
    constructor(public holidaySchoolRequest: HolidaysSchoolRequest, public user: string) {}
  }

  @logDispatcher
  export class AddHolidaySuccess {
    static readonly type = '[Holidays] AddHolidaySuccess';
    constructor() {}
  }

  @logDispatcher
  export class AddHolidays {
    static readonly type = '[Holidays] AddHolidays';
    constructor(public holidaysForm: HolidaysForm, public user: string) {}
  }

  @logDispatcher
  export class AddHolidaysSuccess {
    static readonly type = '[Holidays] AddHolidaysSuccess';
    constructor() {}
  }

  @logDispatcher
  export class DeleteHolidays {
    static readonly type = '[Holidays] DeleteHolidays';
    constructor(public holidaysForm: HolidaysForm, public user: string) {}
  }

  @logDispatcher
  export class DeleteHolidaysSuccess {
    static readonly type = '[Holidays] DeleteHolidaysSuccess';
    constructor() {}
  }

  @logDispatcher
  export class Error {
    static readonly type = '[Holidays] Error';
    constructor(public error: any) {}
  }

  @logDispatcher
  export class SetHolidaysDefaultState {
    static readonly type = '[Holidays] SetHolidaysDefaultState';
    constructor() {}
  }
}
